import { t } from '@citrite/translate';
import { DesktopsIcon, DesktopsSolidIcon } from '@citrite/web-ui-component';
import { LeftNavPositions } from '@citrite/workspace-ui-platform';
import { checkDesktopsAvailability } from 'App/Navigation/checkDesktopsAvailability';
import { Desktop } from 'App/Screen';
import { performance } from 'Components/performance';
import { createLeftNavRoute } from 'Router/ReactRoute';

export const desktopsPagePath = '/desktops';

export const desktopsRoute = createLeftNavRoute({
	component: Desktop,
	path: desktopsPagePath,
	isAvailable: props => checkDesktopsAvailability(props),
	isLoading: props => props.resources.loading,
	getNavLinkProps: () => ({
		icon: DesktopsIcon,
		selectedIcon: DesktopsSolidIcon,
		title: t('Workspace:desktops'),
		weight: LeftNavPositions.desktops,
		performanceMark: performance.events.MobileDesktopsLink_Click,
		analyticsID: 'desktops-nav-tab',
	}),
	pathParams: {},
});
